import {CaseStatus} from './case-status.enum';

/**
 * `GET /api/v1/cases?status=` is bound by Spring MVC to the Kotlin enum constant
 * (`OPEN`), not the `@JsonProperty` display string the JSON body uses (`Open`).
 * Sending the display string is a 400 ("Failed to convert 'status' value 'Open'"),
 * and `In Progress` / `On Hold` are not constant names at all.
 */
const QUERY_VALUE: Record<string, string> = {
  [CaseStatus.OPEN]: 'OPEN',
  [CaseStatus.IN_PROGRESS]: 'IN_PROGRESS',
  [CaseStatus.ON_HOLD]: 'ON_HOLD',
  [CaseStatus.CLOSED]: 'CLOSED',
  [CaseStatus.ARCHIVED]: 'ARCHIVED'
};

/** The `status` query value Spring will convert. A value it already understands is left as-is. */
export function caseStatusQueryValue(status: string): string {
  return QUERY_VALUE[status] ?? status;
}
